export default "__VITE_ASSET__7a9fee33__"